
namespace TabAurous.Sales {
    export class SalesReturnOptions {
        items: SalesReturnMasterRow[];
    }

    export class SalesReturnPanel extends Serenity.TemplatedPanel<SalesReturnOptions> {
        constructor(container: JQuery, opt: SalesReturnOptions) {
            super(container, opt);

            //Grouping
            var data = this.options.items;
            var code = [""];
            var grossamount = [0];
            code.pop();
            grossamount.pop();
            for (var i = 0; i < data.length; i++) {
                var checkexists = false;
                for (var j = 0; j < code.length; j++) {
                    if (data[i].LedgerName.match(code[j])) {
                        checkexists = true;
                        grossamount[j] += data[i].GrossAmount;
                        grossamount[j] = parseFloat(grossamount[j].toFixed(2));
                    }
                }
                if (!checkexists) {
                    code.push(data[i].LedgerName);
                    grossamount.push(parseFloat(data[i].GrossAmount.toFixed(2)));
                }
            }
            var options = {
                chart: {
                    height: 250,
                    width: 430,
                    type: 'line',
                    fontFamily: '"PT Sans", sans-serif',
                    zoom: {
                        enabled: false
                    }
                },
                series: [
                    {
                        name: 'sales',
                        data: grossamount
                    }
                ],

                stroke: {
                    curve: 'straight'
                },
                xaxis: {
                    categories: code
                }
            }
            //var x = document.getElementById('TabAurous_Sales_SalesReturnPanel12_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);
            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class SalesReturnGrid extends Serenity.EntityGrid<SalesReturnMasterRow, any> {
        protected getColumnsKey() { return 'Sales.SalesReturnMaster'; }
        protected getDialogType() { return SalesReturnMasterDialog; }
        protected getIdProperty() { return SalesReturnMasterRow.idProperty; }
        protected getInsertPermission() { return SalesReturnMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesReturnMasterRow.localTextPrefix; }
        protected getService() { return SalesReturnMasterService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        private chartContainer: JQuery;
        private chartPanel: SalesReturnPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.setTitle("");
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row); 
            super.onClick(e, row, cell);
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Sales/SalesReturnMaster/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true


                },
                field: 'PartyId',
                title: 'Customer',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },
                cssClass: 'hidden-xs'
            });


            return filters;
        }
        onViewProcessData(response: Serenity.ListResponse<SalesReturnMasterRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new SalesReturnPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({

            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //});
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Sales Return",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}